import styled from 'styled-components';

const Line = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.border.primary};
`;

export default Line;
